
import './style.scss';
import { Check, Close, DryCleaning } from '@mui/icons-material';
import { Avatar, Box, Divider, List, ListItem, ListItemAvatar, ListItemText, Typography } from '@mui/material';
import { useLanguageContext } from '../../contexts/LanguageContext';
import { useAuthContext } from '../../contexts/AuthContext';
import IGovernanceItem from '../../interfaces/IGovernanceItem';



interface IGovernanceItemsListProps {
    items: (IGovernanceItem & { selected: boolean; executed?: boolean; onClick: () => {}; })[];
    actions?: (item: IGovernanceItem) => JSX.Element | JSX.Element[];
}


const GovernanceItemsList: React.FC<IGovernanceItemsListProps> = ({
    items,
    actions = undefined
}) => {
    const { translate } = useLanguageContext();
    const { enterprise } = useAuthContext();

    return <>
        <List className='itemslist-default governance-itemslist'>
            {
                items.map((item, index) => {
                    const itemProps = {
                        container: {
                            className: ''
                        },
                        avatar: {
                            className: '',
                            Icon: DryCleaning
                        },
                        secondaryText: <></>,
                        executed: <></>
                    };

                    const required = item.required && enterprise?.requireMandatoryGovernanceItemsMarked;
                    if (required) {
                        itemProps.secondaryText = <Typography variant='subtitle2' component='span' className='fontsize-10 fontweight-bold color-red display-flex alignitems-center gap-4'>
                            <Typography component='span' className='fontsize-10'> ✱ </Typography>
                            {translate('required').toUpperCase()}
                        </Typography>;
                    }

                    if (item.selected) {
                        itemProps.container.className = 'selected';
                        itemProps.avatar.className = 'backgroundcolor-primary';
                        itemProps.avatar.Icon = Check;
                    }

                    if (item.executed !== undefined) {
                        const executedProps = {
                            className: 'color-red',
                            name: 'notExecuted',
                            Icon: Close
                        };
                
                        if (item.executed) {
                            executedProps.className = 'color-green';
                            executedProps.name = 'executed';
                            executedProps.Icon = Check;
                        }

                        itemProps.executed = <Typography 
                            variant='subtitle1' 
                            paddingY={0.4}
                            paddingX={1} 
                            className={`display-flex alignitems-center gap-4 fontsize-10 fontweight-bold backgroundcolor-grey-1 borderradius-default ${executedProps.className}`}
                        >
                            <executedProps.Icon className='fontsize-16' />
                            {translate(executedProps.name).toUpperCase()}
                        </Typography>;
                    }

                    return <>
                        {
                            index > 0 && <Divider variant="inset" component="li" className={item.selected ? 'bordercolor-paper' : ''} />
                        }

                        <ListItem 
                            className={`item ${itemProps.container.className}`} 
                            key={item.id} 
                            onClick={e => {
                                const target = e.target as HTMLElement;
                                const parentElement = target.parentElement as HTMLElement;
                                if (target.classList.contains("item-action") || parentElement.classList.contains("item-action")) {
                                    return;
                                }

                                item.onClick();
                            }}
                        >
                            <ListItemAvatar>
                                <Avatar className={`item-avatar ${itemProps.avatar.className}`}> 
                                    <itemProps.avatar.Icon /> 
                                </Avatar>
                            </ListItemAvatar>

                            <ListItemText primary={item.name} secondary={itemProps.secondaryText} className='item-title' />

                            <Box className='item-actions'> 
                                {itemProps.executed}

                                <input 
                                    className='item-input'
                                    type="checkbox" 
                                    name={`governanceItems[${item.id}]`} 
                                    value={item.id} 
                                    checked={item.selected} 
                                    required={required && item.executed === undefined} 
                                />

                                {actions && actions(item)}
                            </Box>
                        </ListItem>
                    </>;
                })
            }
        </List>
    </>;
}

export default GovernanceItemsList;